import React from 'react';

import {
  Container,
  Stack,
} from '@mui/material'
import AuthButton from './AuthButton';
import Login from './Login';
import { StyledButton, SubHeaderText, BodyText } from './_components';
import { useAuth } from '../../hooks/useAuth';


interface ContainerProps {
  toolName: string | React.ReactNode
}
const LoginRegisterContainer = (props: ContainerProps) => {
  const { toolName = 'Stokastic Tools' } = props;
  const { signup, login } = useAuth();

  return (
    <Container>
      <Stack direction='column' alignItems='center' justifyContent='center' rowGap='20px' height={'calc(100vh - 44px)'} >
        <SubHeaderText>You must be logged in to access <span style={{ whiteSpace:'nowrap' }}>{ toolName }.</span></SubHeaderText>
        <Stack
          width='100%'
          direction='column'
          alignItems={{ sm: 'center' }}
          rowGap='10px'
        >
          <StyledButton variant='contained' size='medium' onClick={() => login()}>
            Log in
          </StyledButton>
          {/* <Login button={true} outlined={true} />
          <BodyText sx={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '12px' }}>
            Use email login if you're having trouble with SSO
          </BodyText> */}
          <StyledButton variant='text' size='small' onClick={() => signup()} sx={{ backgroundColor: 'unset !important' }}>
            <BodyText sx={{ textDecorationLine: 'underline', textTransform: 'uppercase' }}>Dont have an account? Create one here</BodyText>
          </StyledButton>
        </Stack>
      </Stack>
    </Container>
  )
}

export default LoginRegisterContainer;
